import { render } from "./UsersPreviewFromSpace.vue?vue&type=template&id=70a41336&scoped=true"
import script from "./UsersPreviewFromSpace.vue?vue&type=script&lang=js"
export * from "./UsersPreviewFromSpace.vue?vue&type=script&lang=js"

import "./UsersPreviewFromSpace.vue?vue&type=style&index=0&id=70a41336&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70a41336"]])

export default __exports__